/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SetScholarshipInProcessRequestViewModel } from "../types/SetScholarshipInProcessRequestViewModel.ts";

export const setScholarshipInProcessRequestViewModelSchema = z.object({
  courseFinancialPersonId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do plano financeiro do aluno. É o único id necessário: o aluno e o tipo de bolsa são derivados dele. Obrigatório.",
      ),
  ),
}) as unknown as ToZod<SetScholarshipInProcessRequestViewModel>;
